// Basic function to compare ordered matches of words in two texts
export function getBasicTextSimilarity(original: string, suggestion: string): number {
  const originalWords = original.split(' ');
  const suggestionWords = suggestion.split(' ');
  let matches = 0;

  suggestionWords.forEach((word) => {
    if (originalWords.includes(word)) matches++;
  });

  const matchPercentage = (matches / originalWords.length) * 100;
  return matchPercentage;
}
